import { useAuthStore } from "@persisted-state/auth/auth.store";

export const SHIPPING_AGENCY_TRANSFER_STATUS = {
  REJECTED: "REJECTED",
  APPROVED: "APPROVED",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  PENDING_MARINE_DEPARTMENT_APPROVAL: "PENDING_MARINE_DEPARTMENT_APPROVAL",
  COMPLETED: "COMPLETED",
} as const;

export const TASK_STATUSES = {
  READY: "READY",
  CLAIMED: "CLAIMED",
  COMPLETED: "COMPLETED",
};

const isTaskNotClaimed = (taskStatus: string) => taskStatus === TASK_STATUSES.READY;

const isTaskClaimed = (taskStatus: string) => taskStatus === TASK_STATUSES.CLAIMED;

const isTaskOwner = (claimOwnerName: string) =>
  claimOwnerName === useAuthStore.getState().user?.preferredUsername;

const isMarineDepartment = () =>
  useAuthStore.getState().userAccessPermissions?.includes("hasTaskAccess");

const isNewCompany = (companyId: string) => companyId === useAuthStore.getState().user?.companyId;

const isUserClaimedTaskOwner = (taskStatus: string, claimOwnerName: string) =>
  isTaskClaimed(taskStatus) && isTaskOwner(claimOwnerName);

export const canUserClaim = (taskStatus: string, status: string, companyId: string) =>
  (isTaskNotClaimed(taskStatus) &&
    isNewCompany(companyId) &&
    status === SHIPPING_AGENCY_TRANSFER_STATUS.PENDING_APPROVAL) ||
  (isTaskNotClaimed(taskStatus) &&
    isMarineDepartment() &&
    status === SHIPPING_AGENCY_TRANSFER_STATUS.PENDING_MARINE_DEPARTMENT_APPROVAL);

export const canUserUnclaim = (taskStatus: string, claimOwnerName: string) =>
  isUserClaimedTaskOwner(taskStatus, claimOwnerName);

export const canUserApprove = (taskStatus: string, claimOwnerName: string, status: string) =>
  isUserClaimedTaskOwner(taskStatus, claimOwnerName) &&
  (status === SHIPPING_AGENCY_TRANSFER_STATUS.PENDING_APPROVAL ||
    status === SHIPPING_AGENCY_TRANSFER_STATUS.PENDING_MARINE_DEPARTMENT_APPROVAL);

export const canUserReject = (taskStatus: string, claimOwnerName: string, status: string) =>
  isUserClaimedTaskOwner(taskStatus, claimOwnerName) &&
  (status === SHIPPING_AGENCY_TRANSFER_STATUS.PENDING_APPROVAL ||
    status === SHIPPING_AGENCY_TRANSFER_STATUS.PENDING_MARINE_DEPARTMENT_APPROVAL);
